import { useEffect, useState } from "react";
import useAnalytics from "hooks/useAnalytics";

export default function StepAddSource({ setSourceUrl, sourceUrl, setSteps }) {
  const [disabled, setDisabled] = useState(true);
  const { track } = useAnalytics();

  useEffect(() => {
    if (sourceUrl === "") {
      setDisabled(true);
      return;
    }
    if (sourceUrl) {
      try {
        new URL(sourceUrl);
        setDisabled(false);
        setSourceUrl(sourceUrl);
      } catch (_) {
        setDisabled(true);
      }
    }
  }, [sourceUrl, setSourceUrl]);
  return (
    <div className="mb-36">
      <h1 className="text-2xl font-bold mb-6">Add a Source</h1>
      <div className="space-y-5">
        <p>
          Help us build the most comprehensive database information about
          murdered or missing people.
        </p>
        <p>
          Add a credible source of information for this case. All sources will
          go through Uncovered’s review process.
        </p>
      </div>
      <div className="mt-5">
        <form onSubmit={() => {
          track("source_citation_url_submitted");
          setSteps("details")
        }}>
          <input
            type="url"
            placeholder="URL to the source"
            className="border px-3 py-2 w-full text-base border-gray-250 rounded"
            onChange={(e) => setSourceUrl(e.target.value)}
            defaultValue={sourceUrl}
          />
          <div className="flex mt-10">
            {/* Hiding per Jim feedback */}
            {/* <button
              href=""
              className="border-yellow-400 border font-bold rounded-md px-5 py-2 hover:bg-yellow-400 transition hover:text-white text-sm"
              type="button"
              onClick={() => setSteps("resolution")}
            >
              This Case is Resolved
            </button> */}
            <button
              className={`ml-auto font-bold rounded-md px-12 py-2 transition text-sm ${
                disabled
                  ? "bg-gray-200 cursor-not-allowed"
                  : "bg-yellow-400 text-white"
              }`}
              type="submit"
              disabled={disabled}
            >
              Next
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
